export const LocalhostLocationRefreshInterval = 1000 * 60;
export const LocationRefreshInterval = 1000 * 60 * 10;
